// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  grid-area: footer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20%;
}

footer {
  background: var(--color-middle);
  padding: 1% 10% 1% 10%;
}
`, "",{"version":3,"sources":["webpack://./src/static/css/footer.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB","sourcesContent":["footer {\n  grid-area: footer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20%;\n}\n\nfooter {\n  background: var(--color-middle);\n  padding: 1% 10% 1% 10%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
